import { useQuery } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const useGetCaseAuditLog = 'get-case-audit-log';

export const useGetCaseAuditLogs = (caseGuid?: string) => {
    const { zoneApiClient }= useZoneContext();
    return useQuery({
        queryKey: [useGetCaseAuditLog, caseGuid],
        queryFn: async () => {
            const response = await zoneApiClient.getCaseAuditLogs(caseGuid ?? '');

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve the audit logs for this case.');
            }

            return response.payload;
        },
        enabled: !!caseGuid,
        cacheTime: 0,
        staleTime: 0,
    });
};
